import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { panelTheme } from '../PanelComerciales.theme';

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title,
    description,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    danger = false,
    onConfirm,
    onCancel,
}) => (
    <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: panelTheme.colors.text }}>{title}</DialogTitle>
        {description ? (
            <DialogContent>
                <Typography variant='body2' sx={{ color: panelTheme.colors.textMuted }}>
                    {description}
                </Typography>
            </DialogContent>
        ) : null}
        <DialogActions>
            <Button onClick={onCancel} sx={{ textTransform: 'none' }}>
                {cancelLabel}
            </Button>
            <Button
                onClick={onConfirm}
                variant='contained'
                sx={{
                    textTransform: 'none',
                    background: danger ? panelTheme.colors.danger : panelTheme.colors.indigo,
                    '&:hover': {
                        background: danger ? '#B91C1C' : panelTheme.colors.violet,
                    },
                }}
            >
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
